export default {
    dashboard: 'Πίνακας ελέγχου',
    athletes: {
        title: 'Πελάτες',
        all: 'Όλοι οι πελάτες',
        statistics: 'Στατιστικά στοιχεία',
        new: 'Προσθήκη νέου πελάτη',
        quickAdd: 'Γρήγορη προσθήκη πελάτη'
    },
    foods: 'Τρόφιμα',
    dietPlans: {
        title: 'Πρότυπα',
        all: 'Πρότυπα πλάνα',
        templates: 'Πρότυπα γεύματα',
        statistics: 'Στατιστικά στοιχεία',
        printTemplates: 'Πρότυπα εκτύπωσης',
        noteTemplates: 'Πρότυπα σημειώσεων',
        recipes: 'Συνταγές'
    },
    scienceTools: 'Επιστημονικά Εργαλεία',
    chat: 'Συνομιλία',
    calendar: 'Ημερολόγιο',
    menu: 'Μενού',
    marketplace: 'vresdiatrofologo',
    pathisis: 'Pathisis',
    noResults: 'Δεν βρέθηκαν αποτελέσματα',
    aCloud: 'aCloud',
    markAsRead: 'Σήμανση ως αναγνωσμένα',
    account: 'Λογαριασμός',
    logout: 'Αποσύνδεση',
    settings: {
        title: 'Ρυθμίσεις',
        mobileFeed: {
            label: 'Ειδοποιήσεις Mobile Feed',
            description: 'Ενεργοποίηση/απενεργοποίηση των ειδοποιήσεων για νέες καταγραφές από τους πελάτες σας.'
        },
        aiPrompts: {
            label: 'AI Prompts',
            description: 'Εμφάνιση ή απόκρυψη των AI prompts.'
        },
        chatBot: {
            label: 'Chat bot',
            description: 'Εμφάνιση ή απόκρυψη του chat bot.'
        },
        prolipsisWidget: {
            label: 'Widget Prolipsis',
            description: 'Εμφάνιση ή απόκρυψη του widget.'
        },
        clientFileUploads: {
            label: 'Αρχεία από πελάτες',
            description: 'Οι πελάτες σας μπορούν να σας στέλνουν φωτογραφίες και PDF από την εφαρμογή. Αν το απενεργοποιήσετε, κανένας πελάτης δεν θα μπορεί να σας στείλει αρχεία.'
        }
    },
    news: {
        title: 'Ειδοποιήσεις',
        filterAll: 'Όλες',
        filterMeals: 'Καταγραφές',
        filterUpdates: 'Ενημερώσεις',
        newMealLog: 'Νέα καταγραφή από',
        update: 'Ενημέρωση',
        today: 'Σήμερα',
        yesterday: 'Χθες',
        noItems: 'Όλα ενημερωμένα',
        noItemsText: 'Νέες καταγραφές πελατών και ενημερώσεις του athlisis θα εμφανίζονται εδώ.',
        noNews: 'Δεν υπάρχουν ενημερώσεις',
        noNewsText: 'Τα νέα και οι ανακοινώσεις του athlisis θα εμφανίζονται εδώ.',
        noMeals: 'Καμία νέα καταγραφή',
        noMealsText: 'Ό,τι καταγράφουν οι πελάτες σου στην εφαρμογή θα εμφανίζεται εδώ.',
        manageNotifications: 'Διαχείριση ειδοποιήσεων'
    }

}
